(() => {
  const SELECTOR = '[data-omnee-announcement-marquee]';

  function buildTrack(root) {
    const frame = root.querySelector('.omnee-announcement-marquee__frame');
    const track = root.querySelector('.omnee-announcement-marquee__track');
    const sourceGroup = track?.querySelector('.omnee-announcement-marquee__group');

    if (!frame || !track || !sourceGroup) return;

    const sourceClone = sourceGroup.cloneNode(true);
    sourceClone.removeAttribute('aria-hidden');
    track.replaceChildren(sourceClone);

    const sourceWidth = Math.ceil(sourceClone.getBoundingClientRect().width);
    const frameWidth = Math.ceil(frame.getBoundingClientRect().width);

    if (!sourceWidth || !frameWidth) return;

    let totalWidth = sourceWidth;
    let safety = 0;

    while (totalWidth < sourceWidth + frameWidth && safety < 12) {
      const clone = sourceClone.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
      totalWidth += sourceWidth;
      safety += 1;
    }

    root.style.setProperty('--omnee-marquee-distance', `-${sourceWidth}px`);
  }

  function setupMarquee(root) {
    if (!root || root.__omneeAnnouncementMarqueeInitialized) return;

    let resizeFrame = null;

    const queueBuild = () => {
      if (resizeFrame) cancelAnimationFrame(resizeFrame);

      resizeFrame = requestAnimationFrame(() => {
        resizeFrame = null;
        buildTrack(root);
      });
    };

    root.__omneeAnnouncementMarqueeInitialized = true;
    root.__omneeAnnouncementMarqueeQueueBuild = queueBuild;

    window.addEventListener('resize', queueBuild);

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(queueBuild);
      resizeObserver.observe(root);
      root.__omneeAnnouncementMarqueeResizeObserver = resizeObserver;
    }

    queueBuild();
  }

  function initializeAnnouncementMarquees(scope = document) {
    const roots = scope.matches?.(SELECTOR) ? [scope] : Array.from(scope.querySelectorAll(SELECTOR));
    roots.forEach(setupMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAnnouncementMarquees(), { once: true });
  } else {
    initializeAnnouncementMarquees();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => initializeAnnouncementMarquees(event.target));
  }
})();
